import Axios from '../helper/Axios';

export interface S3UploadInitRequest {
  fileName: string;
  contentType: string;
  partCount: number;
}

export interface S3UploadInitResponse {
  uploadId: string;
  partUrls: string[];
}

export interface S3UploadCompleteRequest {
  fileName: string;
  uploadId: string;
  parts: {
    partNumber: number;
    eTag: string;
  }[];
}

export interface S3UploadAbortRequest {
  fileName: string;
  uploadId: string;
}

export class S3FileService {
  private static baseUrl = '/s3upload';

  static async createMultipartUpload(request: S3UploadInitRequest): Promise<S3UploadInitResponse> {
    const response = await Axios.post<S3UploadInitResponse>(
      `${this.baseUrl}/create-multipart`,
      request
    );

    return response.data;
  }

  static async completeMultipartUpload(request: S3UploadCompleteRequest): Promise<void> {
    await Axios.post(`${this.baseUrl}/complete-multipart`, request);
  }

  static async abortMultipartUpload(request: S3UploadAbortRequest): Promise<void> {
    await Axios.post(`${this.baseUrl}/abort-multipart`, request);
  }

  static async uploadPartToPresignedUrl(url: string, chunk: Blob): Promise<string> {
    const response = await fetch(url, {
      method: 'PUT',
      body: chunk,
    });

    if (!response.ok) {
      throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
    }

    const eTag = response.headers.get('ETag') || response.headers.get('etag');

    if (!eTag) {
      throw new Error('ETag not found in response headers');
    }

    return eTag.replaceAll('"', '');
  }

  static async getPresignedPutUrl(params: {
    fileKey: string;
    contentType: string;
  }): Promise<string> {
    const response = await Axios.get<string>(
      `${this.baseUrl}/get-put-url`,
      { params }
    );

    if (!response.data) {
      throw new Error('Failed to get presigned URL');
    }
    
    return response.data;
  }
}